export default {
  common: {
    print: '印刷',
    fare: '運賃',
    restaurant: 'レストラン利用料金'
  },
  error: {
    invalidParameters:
      'URLが正しくないか、必要な情報が不足しています。お手数ですが、正しいリンクから再度アクセスしてください。',
    documentNotFound: '帳票情報を取得できませんでした。'
  },
  receipt: {
    title: '領収書',
    organizationTitle: '御中',
    personTitle: '様',
    number: 'No.',
    issueData: '発行日',
    corporateNumber: '登録番号',
    amountTips:
      '但、黒部峡谷鉄道トロッコ列車({{businessType}})として\n上記正に領収いたしました。',
    price: '金額',
    priceUnit: '￥{{price}}',
    afterTax: '（税込）',
    afterTaxPrice: '税抜金額',
    taxPrice: '内、消費税({{taxRate}}%})',
    issuer: `{{name}}\n〒：{{postalCode}}\n住所：{{address}}\n電話：{{phone}}`,
    tips: '＊A4縦に印刷し、下部の余白は切ってお使いください。'
  },
  invoice: {
    title: {
      fare: '運賃請求書',
      restaurant: 'レストラン請求書'
    },
    info: {
      organizationTitle: '{{agentName}} 御中',
      personTitle: '{{agentName}} 様',
      tip: '毎々格別のお引き立てを賜り、誠にありがとうございます。下記の通り、ご請求申し上げます。'
    },
    infoDate: {
      COUPON: 'お支払い期限',
      PREPAID: 'お支払い期限',
      MONTHLY: 'お支払い期限',
      CASH: 'お支払い期限',
      OTHER: 'お支払い期限'
    },
    bill: {
      title: 'ご請求金額（税込）'
    },
    bookingInfo: {
      left: {
        participantCount: '人数合計',
        responsibilityPassengerCount: '責任人員',
        groupType: '団体区分',
        serviceDate: '利用日',
        time: '乗車時刻',
        serviceName: '便名',
        notApplicable: '適用なし'
      },
      right: {
        groupBookingNo: '予約番号',
        groupName: '団体名/ツアー名',
        tourNumber: 'ツアー番号'
      }
    },
    restaurantInfo: {
      participantCount: '人数合計',
      bookingNo: '予約番号',
      groupName: '団体名/ツアー名',
      serviceDate: '利用日',
      serviceTime: '利用時間'
    },
    table: {
      allAmount: '総額 (1)+(2)+(3)（税込）',
      total: '合計',
      allPaidAmount: 'お支払い済額',
      requestAmount: 'ご請求金額',
      taxDiff: '税率区分',
      tax: '消費税',
      amount: '金額（税込）',
      memo: '備考',
      no: 'No.',
      menu: 'メニュー',
      unitPrice: '単価',
      quantity: '予約数',
      lineAmount: '合計額',
      mealTotal: '総額'
    },
    tax: '消費税額',
    agent: {
      date: '発行日',
      invoiceId: '請求番号',
      corporateNumber: '登録番号',
      postalCode: '〒',
      address: '住所',
      phone: '電話'
    },
    paymentDueDate: 'お支払い期限',
    taxDetail: '税金詳細',
    feeDetail: '料金詳細',
    requestedCount: '人数',
    confirmedCount: '確定',
    fareAmount: '運賃',
    general: '一般',
    disabled: '障がい者',
    caregiver: '介護者',
    tourConductor: '添乗員',
    total: '合計',
    passengerReductionFee: '旅客運賃減額',
    relaxCarriageFee: 'リラックス車両料金',
    totalAmount: '合計額',
    participantTotal: '人数合計',
    fareTotalLabel: '運賃合計(1)',
    passengerReductionFeeTotal: '減員手数料合計(2)',
    relaxCarriageFeeTotal: 'リラックス車両料金(3)',
    grandTotal: '総額(1)+(2)+(3)'
  },
  rebate: {
    title: {
      fare: 'リベート支払明細書（運賃利用分）',
      restaurant: 'リベート支払明細書（レストラン利用分）'
    },
    info: {
      invoiceNumber: '登録番号',
      tip: '毎々格別のお引き立てを賜り、誠にありがとうございます。下記の通りご案内申し上げます。'
    },
    bill: {
      title: 'リベート返金額'
    },
    agent: {
      issueDate: '発行日',
      statementNumber: '明細書番号',
      corporateNumber: '登録番号'
    },
    serviceInfo: {
      paymentDate: '支払日',
      participantCount: '人数合計',
      groupType: '団体区分',
      serviceDate: '利用日',
      boardingTime: '乗車時刻',
      useTime: '利用時間',
      serviceName: '便名',
      restaurantName: 'レストラン名'
    },
    detail: {
      title: 'リベート返金額詳細',
      usageAmount: {
        fare: '運賃利用額',
        restaurant: 'レストラン利用額'
      },
      usedServiceName: '利用したサービス名',
      rebateBasis: 'リベート適用基準',
      rebateRate: 'リベート率',
      rebateAmount: 'リベート返金額'
    },
    memo: '備考'
  }
};
